export default __webpack_public_path__ + "static/media/Q2.1c00f65a.jpg";